var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSteelIcon = function SvgSteelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.311,
    height: 36.311
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "steel-icon_svg__a",
    width: 36.311,
    height: 36.311,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5615"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#steel-icon_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 210",
    style: {
      fill: "rgba(150,54,39,.86)",
      stroke: "#fff"
    },
    transform: "rotate(-1 423.431 -570.495)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5645"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43 10.265H3.565l.021-1.951-1.721 1.951H0l2.384-2.648h1.21l.035-3.292L5.96 2.1v.007L7.819 0v1.62L5.96 3.71V7.6L3.852 9.946l2.1-2.329h1.781l.087-.1V9.14l-2.39 2.684z",
    "data-name": "Union 11",
    style: {
      opacity: 0.3,
      fill: "#fff"
    },
    transform: "translate(14.246 9.244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.473-10.076v-1.588h5.43v1.588H.144v5.943h1.814v1.588h-5.43v-1.587h1.814v-5.943z",
    "data-name": "Path 3936",
    style: {
      fill: "#fff"
    },
    transform: "translate(17.719 23.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-16331.961-15394.088 2.363-2.678h-5.426l-2.355 2.678z",
    "data-name": "Path 3938",
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    transform: "translate(16351.638 15406.037)"
  }))));
};
export { SvgSteelIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";